<template>
    <div style="width: 100%">
        <Breadcrumb></Breadcrumb>
        <div style="text-align: right;margin: 10px 0">
            <el-row>
                <el-col :span="24">
                    <el-button type="primary" @click="addWare" size="small">添加仓库</el-button>
                </el-col>
            </el-row>
        </div>
        <!--表格-->
        <div>
            <template>
                <el-table
                        border
                        :data="tableData"
                        style="width: 100%">
                    <el-table-column label="序号" type="index" :index="indexMethod" align="center" width="80"></el-table-column>
                    <el-table-column prop="wareName" label="仓库名称" width="300" align="center">
                        <template slot-scope="scope">
                            <span v-text="scope.row.wareName"></span>
                            <span v-if="scope.row.wareName == '无仓库'" style="color: red">（仅使用商品SKU，不使用仓库）</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="address" label="仓库地址" align="center"></el-table-column>
                    <el-table-column prop="takeName" label="负责人" width="180" align="center"></el-table-column>
                    <el-table-column prop="isDefault" label="默认状态" width="100" align="center">
                        <template slot-scope="scope">
                            <div v-if="scope.row.isDefault">
                                <svg-icon icon-class="right"/>
                            </div>
                            <div v-else style="font-size: 13px">
                                <a style="text-decoration: none;color: #4934b2" href="javascript:void(0)" @click="setDefaultStore(scope.row)">设为默认</a>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="handel" label="操作" align="center" width="150">
                        <template slot-scope="scope">
                            <el-button type="text" size="mini"  icon="el-icon-edit" @click="editRow(scope.row)">编辑</el-button>
                            <el-button type="text" size="mini"  icon="el-icon-delete" @click="deleteRow(scope.row)" v-if="scope.row.isManual && !scope.row.isDefault">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <!--分页-->
                <div class="block" style="text-align: right">
                    <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page.sync="page.currentPage1"
                            :page-size="page.pageSize"
                            layout="total, prev, pager, next"
                            :total="total" background>
                    </el-pagination>
                </div>
            </template>
        </div>
        <!--编辑仓库-->
        <el-dialog :close-on-click-modal="false"   class="ware-dialog" :title="title" :visible.sync="wareFormVisible" :destroy-on-close=true
                   @close="closeDia">
            <el-form :model="wareForm" :rules="rules" ref="wareForm" style="margin: 10px" label-width="100px">
                <el-form-item prop="wareId" style="display: none">
                    <el-input v-model="wareForm.wareId"></el-input>
                </el-form-item>
                <el-form-item prop="wareName" label="仓库名称: " label-width="100px">
                    <el-input size="small" v-model="wareForm.wareName" autocomplete="off" style="width: 200px;"></el-input>
                </el-form-item>
                <el-form-item label="负责人: " prop="takeName">
                    <el-input size="small" v-model="wareForm.takeName" autocomplete="off" style="width: 200px;"></el-input>
                </el-form-item>
                <el-form-item label="联系电话: " prop="phone">
                    <el-input size="small" v-model.number="wareForm.tel" maxlength="11" autocomplete="off" style="width: 200px;" onkeyup="this.value = this.value.replace(/[^\d.]/g, '')"></el-input>
                </el-form-item>
                <div style="display: flex">
                    <el-form-item label="所在地区: ">
                        <el-select clearable  size="small" style="width: 170px" v-model="wareForm.prov" placeholder="省" @change="provinceChange">
                            <el-option
                                    v-for="item in provinceOptions"
                                    :key="item.code"
                                    :label="item.name"
                                    :value="item.code">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item prop="city" label-width="10px">
                        <el-select clearable  size="small" style="width: 170px" v-model="wareForm.city" placeholder="市" @change="cityChange">
                            <el-option
                                    v-for="item in cityOptions"
                                    :key="item.code"
                                    :label="item.name"
                                    :value="item.code">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item prop="county" label-width="10px">
                        <el-select clearable  size="small" style="width: 170px" v-model="wareForm.county" placeholder="区">
                            <el-option
                                    v-for="item in areaOptions"
                                    :key="item.code"
                                    :label="item.name"
                                    :value="item.code">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </div>
                <el-form-item label="中文地址: " prop="wareAddr">
                    <el-input type="textarea" v-model="wareForm.wareAddr"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="closeWareFormDialog">取 消</el-button>
                <el-button size="small" type="primary" @click="submitForm">确 定</el-button>
            </div>
        </el-dialog>

    </div>
</template>

<script>
    import Breadcrumb from '@/components/common/Breadcrumb'
    import {getAllStore,updateDefaultState,saveOrUpdate,delStore,loadAreaData} from '@/api/store/storeSet'
    export default {
        components:{Breadcrumb},
        data() {
            return {
                total:0,
                page: {
                    currentPage1: 1,
                    pageSize: 10,
                },
                wareForm: {
                    wareId:null,//仓库id
                    wareName: '',//仓库名称
                    takeName: '',//负责人
                    tel: null,//联系电话
                    addr: '',
                    prov: '110000',
                    city: '',
                    county: '',
                    wareAddr:null  //中文地址
                },
                //弹框变量
                title:null,
                wareFormVisible:false,
                //验证
                rules: {
                    wareName: {required: true, message: '仓库名称不能为空'}
                },
                tableData: [],
                provinceOptions:[],//省
                cityOptions:[],//市
                areaOptions:[],//区


            };
        },
        created(){
            this.loadProvData();
            this.loadWareData();
        },
        mounted(){

        },
        methods: {
            loadWareData(){
                getAllStore(this.page).then(res =>{
                    this.total = res.total;
                    this.tableData = res.rows;
                }).catch(err =>{})
            },
            //dia关闭前清空数据
            closeDia() {
                for (let key in this.wareForm) {
                    this.wareForm[key] = null;
                }
            },
            //获取省市区数据
            loadProvData(){
                var that = this;
                $.ajax({
                    url:process.env.BASE_URL+'areaData.json',
                    method:'get',
                    success:function (res) {
                        that.provinceOptions = res['regionalDivision'];
                    },
                    error:function (err) {}
                });
            },
            //三级联动
            provinceChange(val) {
                console.log(val);
                this.cityOptions = [];
                this.provinceOptions.forEach(item =>{
                    if(item.code == val){
                        this.cityOptions = item.city;
                    }
                })
                //清空区的值
                this.wareForm.city = null;
                this.wareForm.county = null;
                this.areaOptions = [];
            },
            cityChange(val) {
                this.areaOptions = [];
                this.cityOptions.forEach(item =>{
                    if(item.code == val){
                        this.areaOptions = item.district;
                        return;
                    }
                })
                this.wareForm.county = null;
            },
            //序号
            indexMethod(index) {
                return index + 1;
            },
            addWare(){
                this.title = '添加仓库';
                this.wareFormVisible = true;
                this.$refs['wareForm'].resetFields();
            },
            //编辑仓库
            editRow(row) {
                console.log(row);

                var provArr = this.provinceOptions.filter(pro =>{
                    return row.prov == pro.code;
                });
                if(provArr.length > 0){
                    this.cityOptions = provArr[0].city;
                }

                var cityArr = this.cityOptions.filter(c =>{
                    return row.city = c.code;
                });
                if(cityArr.length > 0){
                    this.areaOptions = cityArr[0].district;
                }
                this.title = '编辑仓库';
                //循环赋值
                for (let key in this.wareForm) {
                    this.wareForm[key] = row[key];
                }
                this.wareFormVisible = true;
            },
            //删除仓库
            deleteRow(row){
                this.$confirm('确定删除仓库：'+row.wareName + ' 吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    delStore(row.wareId).then(res =>{
                        if(res.code == 200){
                            this.$message.success("删除成功");
                            this.loadWareData();
                        }
                    }).catch(err =>{});
                }).catch(() => {
                });

            },
            handleSizeChange(val) {
                this.page.pageSize = val;
                this.loadWareData();
            },
            handleCurrentChange(val) {
                this.page.currentPage = val;
                this.loadWareData();
            },
            closeWareFormDialog(){
                this.wareFormVisible = false;
            },
            submitForm(){
                saveOrUpdate(this.wareForm).then(res =>{
                    if(res.code == 200){
                        this.$message.success("操作成功");
                        this.wareFormVisible = false;
                        this.loadWareData();
                    }
                }).catch(err =>{});
            },
            setDefaultStore(row){
                updateDefaultState(row.wareId).then(res =>{
                    if(res.code == 200){
                        this.$message.success("设置成功");
                        this.loadWareData();
                    }
                }).catch(err =>{});
            },
        }
    }
</script>

<style>
    .ware-dialog .el-form-item{margin-bottom: 11px !important;}
    .ware-dialog .el-form-item .el-form-item__error{padding-top: initial !important;}
</style>
